import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcLink16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup as PopupComponent } from '@gem/popups';
import { Button, ButtonTypes, PopupFooter } from '@gem/ui-kit';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';
import { IShareSelection } from 'APP/types/share';

import { ShareDataView } from '../../components/ShareDataView/ShareDataView';
import { useButtonsShareCardPresenter } from './ShareCardPopup.presenter';
import styles from './ShareCardPopup.styles.m.css';

export interface IShareCardPopupParams {
  cardDeepLink: string;
  onSubmit(selection: IShareSelection[]): Promise<void>;
}

export const ShareCardPopup: FC<ICommonPopupsProps<IShareCardPopupParams>> = observer((props) => {
  const { params, popupInstance } = props;
  const { cardDeepLink, onSubmit } = params!;
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard(cardDeepLink, t('common_link_copied'));

  const presenter = useButtonsShareCardPresenter({ onSubmit });

  return (
    <PopupComponent
      isOpened
      isHidden={popupInstance.isHidden}
      onClose={popupInstance.close}
      title={t('card_share_with')}
    >
      <ShareDataView
        multiselect
        onChangeSelection={presenter.onSelect}
      />
      <PopupFooter className={classNames(styles.footer)}>
        {cardDeepLink && (
          <button
            className={styles.copyLink}
            onClick={copyToClipboard}
          >
            <IcLink16Icon className={styles.copyLinkIcon} />
            <span className={styles.copyLinkText}>{t('common_copy_link')}</span>
          </button>
        )}
        <div className={styles.submitBtn}>
          <Button
            type={ButtonTypes.Submit}
            isDisabled={!presenter.hasSelected}
            isLoading={presenter.isSubmitting}
            onClick={presenter.submit}
            theme="primary"
          >
            {t('send')}
          </Button>
        </div>
      </PopupFooter>
    </PopupComponent>
  );
});
